/* TSO — branded dropdown (theme-wide).
   Progressive enhancement: replaces the browser-drawn option menu of a <select>
   with the branded <details> dropdown (chamfered trigger, steel menu, orange
   scrollbar). The native <select> stays in the DOM (hidden) as the form value +
   no-JS fallback; option clicks write to it and dispatch a bubbling `change`, so
   existing handlers keep working. Options re-sync if the select is repopulated.
   Design source: tso-components.css `.tso-dropdown`.

   Deliberately SKIPS dynamic/critical selects (address country/province,
   variant pickers, localization) — those keep the branded native skin so their
   own JS (option repopulation, availability) is never disturbed. Opt any select
   out with `data-no-dd`. */
(function () {
  if (window.__cpbDropdown) return;
  window.__cpbDropdown = true;

  function label(sel) {
    var o = sel.options[sel.selectedIndex];
    return o ? (o.textContent || o.value).trim() : '';
  }

  function skip(sel) {
    if (sel.__cpbDD || sel.multiple || sel.size > 1) return true;
    if (sel.hasAttribute('data-cpb-driven') || sel.hasAttribute('data-no-dd')) return true;
    // Selects wired to their own JS (option repopulation, availability, form
    // re-render) keep the branded NATIVE skin instead — never disturb their logic.
    if (sel.closest('variant-selects, .product-form__input, localization-form, .shopify-payment-button, facet-filters-form, .facets, .mobile-facets')) return true;
    var key = ((sel.id || '') + ' ' + (sel.name || '')).toLowerCase();
    if (/countr|province|zone|sort_by/.test(key)) return true; // address + market/language + collection sort
    return false;
  }

  function build(sel) {
    if (skip(sel)) return;
    sel.__cpbDD = true;

    var dd = document.createElement('details');
    dd.className = 'cpb-dd';
    var sum = document.createElement('summary');
    sum.className = 'cpb-dd__trigger';
    sum.setAttribute('aria-haspopup', 'listbox');
    var lbl = document.createElement('span');
    lbl.className = 'cpb-dd__label';
    var caret = document.createElement('span');
    caret.className = 'cpb-dd__caret';
    caret.setAttribute('aria-hidden', 'true');
    sum.appendChild(lbl);
    sum.appendChild(caret);
    dd.appendChild(sum);
    var menu = document.createElement('div');
    menu.className = 'cpb-dd__menu';
    menu.setAttribute('role', 'listbox');
    dd.appendChild(menu);

    function sync() {
      lbl.textContent = label(sel);
      var kids = menu.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
      }
    }

    function renderOpts() {
      menu.textContent = '';
      Array.prototype.forEach.call(sel.options, function (o, i) {
        // A hidden <option> is one its owner removed from reach (the builder
        // fitment filter hides + disables values with no fitting variant) —
        // never draw it. Disabled-but-visible stays drawn, greyed.
        if (o.hidden) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cpb-dd__opt';
        b.setAttribute('role', 'option');
        b.textContent = o.textContent.trim();
        if (o.disabled) { b.disabled = true; b.style.opacity = '.4'; }
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (o.disabled) return;
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
          dd.removeAttribute('open');
        });
        menu.appendChild(b);
      });
      sync();
    }

    renderOpts();
    sel.classList.add('cpb-dd-native');
    sel.parentNode.insertBefore(dd, sel.nextSibling);
    sel.addEventListener('change', sync);

    // Re-sync if the select is repopulated, or if an owner toggles an
    // option's hidden/disabled AFTER build (the builder fitment filter does
    // exactly that on vehicle change — a childList-only observer left the
    // filtered F-450 clickable in the branded menu, caught live 2026-09-13).
    if ('MutationObserver' in window) {
      new MutationObserver(renderOpts).observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'disabled'] });
    }

    document.addEventListener('click', function (e) {
      if (dd.open && !dd.contains(e.target)) dd.removeAttribute('open');
    });
    dd.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dd.removeAttribute('open');
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('select').forEach(build);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });
})();
